<script setup lang="ts">
defineProps<{ description: string }>();
const { t } = useI18n();
</script>

<template>
  <div class="product-info">
    <div v-if="description" class="product-info__item">
      <div class="product-info__title">{{ t('description') }}</div>
      <div class="product-info__description">
        {{ description }}
      </div>
    </div>
  </div>
</template>

<style lang="less">
.product-info {
  .flex-column(@size-x8);

  &__item {
    .flex-column(@size-x4);
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    line-height: 130%;
    word-break: break-word;
  }

  &__description {
    font-size: @size-x4;
    font-weight: 400;
    line-height: 130%;
    word-break: break-word;
  }

  @media @1024 {
    &__item {
      gap: @size-x3;
    }

    &__characteristics {
      gap: @main-size;
    }

    &__description,
    &__characteristic-key,
    &__characteristic-value {
      font-size: 14px;
    }
  }
}
</style>
